<template>
  <v-card class="pa-2">
    <template v-slot:append>
      <v-btn icon="mdi-close" variant="text" @click="$emit('closeCard')"></v-btn>
    </template>

    <template v-slot:title>
      Update Story
    </template>

    <v-card-text>
      <QuillEditor
        v-model:content="textAreaData"
        content-type="html"
        theme="snow"
        class="opacity-50"
        @update:content="modelData"
      />
    </v-card-text>

    <v-card-actions>
      <v-row justify="end" class="dialogBottom" v-if="!showReadOnly">
        <v-btn class="mr-2 cancel" @click="$emit('closeCard')">Cancel</v-btn>
        <v-btn class="save" type="submit" @click="submit" :loading="submitting">
          Save
        </v-btn>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import { QuillEditor } from '@vueup/vue-quill'

export default {
  components: {
    QuillEditor
  },
  props: ["allowEdit", "nameRule", "submit", "submitting", "storyData"],
  data() {
    return {
      textAreaData:''
    };
  },
  created(){
    if(this.storyData && this.storyData.question_story){
      this.textAreaData = this.storyData.question_story
    }
  },
  methods:{
    modelData(){
      this.$emit('textAreaData',this.textAreaData)
    }
  }
};
</script>

